import { useContext } from "react"
import { AuthContext } from "../providers/AuthProvider"

const GetUser = () => {
    const { user } = useContext(AuthContext)

    return user
}

export default GetUser